"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FormMixin = require("../../mixins/components/FormMixin");
/**
 * An HTML [form element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
 * The component itself does nothing other than provide layout for nested form components.
 *
 * @related ['FormActions']
 * @since 8.0.0
 */
var Form = /*#__PURE__*/_styledComponents.default.form.withConfig({
  displayName: "Form",
  componentId: "c11n-8-107-0__sc-iqxs9k-0"
})(["", ""], _FormMixin.FormMixin);
exports.Form = Form;
Form.displayName = 'Form';
Form.propTypes = {
  /**
   * You can change the type of the component using the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop).
   *
   * By default, this is a `"form"`, but you may want to change this to `"section"` or `"div"` if
   * you only want form layout without the native form functionality of `onSubmit`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
};
Form.defaultProps = {
  as: 'form'
};

/** @component */